import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
import "./export-cdcbfb2b.js";
var u = function() {
  var t = 0;
  return function(o) {
    var n = (/* @__PURE__ */ new Date()).getTime() + t;
    return t++, typeof globalThis < "u" && globalThis.crypto && typeof globalThis.crypto.randomUUID == "function" ? o ? o + "-" + globalThis.crypto.randomUUID() : globalThis.crypto.randomUUID() : o ? o + "-" + n : "" + n;
  };
}();
export {
  u as uniqueId
};
